<template>
  <div class="adv-listing-filters-clear">
    <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn">{{ t('filters.clear.all') }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedFiltersClear',
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-filters-clear {
  position: relative;
  display: grid;
  align-items: center;
  width: 100%;
  height: 100%;
  &-btn {
    display: block;
    text-align: center;
    font-size: 13px;
    line-height: 1.2;
    color: black;
    border: 1px solid var(--prime2);
    border-radius: 8px;
    padding: 10px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
